import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, mergeMap, tap } from "rxjs/operators";
import { ApplicationConstants } from "../helpers/application-constants.helper";

export class DebounceTrigger<T> extends Subject<T> {
    constructor(public func: (e:any) => any, public dedounceTime: number = ApplicationConstants.debounceTimeInMilliSeconds, public minInputLength: number = 3) {
        super();
        this.initialize();
    }
    initialize() {
        this.pipe(
            debounceTime(this.dedounceTime),
            tap((e:T) => {
                return this.func(e);
            })
        ).subscribe(); //reinitailize when the event is fired
    }

    execute(e: T = null) {
        this.next(e);
        
    }
}